import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../hooks/useAuth.js";
import { Spinner } from "./States.js";

/**
 * Route guard for the admin area.
 *
 * This is a convenience, not a security boundary — it only hides UI. Every
 * admin action is re-checked on the server against the role stored in the
 * database, so editing `role` in devtools changes what is drawn and nothing
 * about what the API will accept.
 */
export function RequireAdmin() {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Spinner label="Checking your account" />;

  if (!user) {
    return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return (
      <div className="mx-auto max-w-md px-5 py-24 text-center">
        <h1 className="font-display text-4xl text-paper-50">Not your area</h1>
        <p className="mt-3 text-paper-400">
          Only Davis can publish reviews. If you think this is a mistake, get in
          touch.
        </p>
      </div>
    );
  }

  return <Outlet />;
}
